<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <card
          color="green"
          title="Branchen Liste"
          :search="search"
          @changed="handleChange">
          <v-data-table
            :headers="headers"
            :items="events"
            :loading="loading"
            :search="search"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.date }}</td>
              <td>{{ props.item.toDate }}</td>
              <td>{{ props.item.title }}</td>
              <td width="156">
                <dlg-event-edit :event="props.item"/>
                <dlg-event-delete :event="props.item"/>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Veranstaltung "{{ search }}" konnte nicht gefunden werden.
            </v-alert>
          </v-data-table>
        </card>
        <v-card>

        </v-card>
      </v-flex>
    </v-layout>

    <dlg-event-new/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DlgEventEdit from '@/modules/event/_components/DlgEventEdit';
import DlgEventDelete from '@/modules/event/_components/DlgEventDelete';
import DlgEventNew from '@/modules/event/_components/DlgEventNew';
import Card from '@/components/material/Card';

export default {
  name: 'eventList',
  components: {
    Card,
    DlgEventNew,
    DlgEventDelete,
    DlgEventEdit,
  },
  data() {
    return {
      headers: [
        {
          text: 'Von',
          align: 'left',
          value: 'parsedDate',
        },
        {
          text: 'Bis',
          align: 'left',
          value: 'parsedToDate',
        },
        {
          text: 'Name',
          align: 'left',
          value: 'title',
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: '',
        },
      ],
      loading: false,
      search: '',
      pagination: {
        descending: true,
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    ...mapGetters({
      events: 'event/parsed',
    }),
  },
  methods: {
    ...mapActions({
      readEvents: 'event/read',
    }),
    handleChange(e) {
      this.search = e;
    },
  },
  mounted() {
    this.loading = true;
    this.readEvents().then(() => {
      this.loading = false;
    });
  },
};
</script>

<style scoped>

</style>
